export const AVLTREE_CLEAR_ALL = 'AVLTREE_CLEAR_ALL'

export const AVLTREE_STEP_UP = 'AVLTREE_STEP_UP'
export const AVLTREE_STEP_DOWN = 'AVLTREE_STEP_DOWN'

export const AVLTREE_INSERT_ROOT = 'AVLTREE_INSERT_ROOT'
export const AVLTREE_BALANCE_ROOT = 'AVLTREE_BALANCE_ROOT'
export const AVLTREE_DELETE_ROOT = 'AVLTREE_DELETE_ROOT'

export const AVLTREE_INSERT_INPUT_CHANGED = 'AVLTREE_INSERT_INPUT_CHANGED'
export const AVLTREE_CLEAR_INSERT_INPUT_CHANGED = 'AVLTREE_CLEAR_INSERT_INPUT_CHANGED'
export const AVLTREE_DELETE_INPUT_CHANGED = 'AVLTREE_DELETE_INPUT_CHANGED'
export const AVLTREE_CLEAR_DELETE_INPUT = 'AVLTREE_CLEAR_DELETE_INPUT'

export const AVLTREE_UPDATE_MSG = 'AVLTREE_UPDATE_MSG'
export const AVLTREE_CLEAR_MSG = 'AVLTREE_CLEAR_MSG'

export const AVLTREE_SET_MODE = 'AVLTREE_SET_MODE'
export const AVLTREE_CLEAR_MODE = 'AVLTREE_CLEAR_MODE'

export const AVLTREE_ENABLE_CONTROLS = 'AVLTREE_ENABLE_CONTROLS'
export const AVLTREE_DISABLE_CONTROLS = 'AVLTREE_DISABLE_CONTROLS'

export const AVLTREE_ENABLE_INSERT = 'AVLTREE_ENABLE_INSERT'
export const AVLTREE_DISABLE_INSERT = 'AVLTREE_DISABLE_INSERT'

export const AVLTREE_ENABLE_DELETE = 'AVLTREE_ENABLE_DELETE'
export const AVLTREE_DISABLE_DELETE = 'AVLTREE_DISABLE_DELETE'

export const AVLTREE_TOGGLE_STEPPING = 'AVLTREE_TOGGLE_STEPPING'